<!--计费方案列表-->
<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">计费方案</span>
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>收费单价不能为空，设备如需免费使用，请将对应项的单价设置为0
      </div>
    </div>
    <div class="content-header">
      <div class="left">
        <Input
          v-model="page.value"
          placeholder="根据条件搜索"
          @on-enter="getData(1)"
        >
          <Select v-model="page.cond" slot="prepend" style="width: 100px">
            <Option value="charge.id">方案编号</Option>
            <Option value="charge.name">方案名称</Option>
            <Option value="user_agent.name" v-if="!user.tp">所属</Option>
          </Select>
          <Button slot="append" icon="ios-search" @click="getData(1)"></Button>
        </Input>
        <Button @click="resest" style="margin: 2px 0 0 5px">重置</Button>
      </div>
      <div class="right">
        <Poptip trigger="hover" title="筛选" content="content" placement="left">
          <Button icon="md-list-box" style="margin: 0 5px 1px 0"></Button>
          <div slot="content" class="group">
            <Button
              size="small"
              style="margin: 0 5px 5px 0"
              v-for="(item, index) in col"
              :key="index"
              :type="item.show ? 'primary' : 'default'"
              @click="item.show = !item.show"
            >
              <span>{{ item.title }}</span>
            </Button>
          </div>
        </Poptip>
        <!-- <Select v-model="page.is_del" style="margin-right:5px">
          <Option :value="0">计费方案列表</Option>
          <Option :value="1">回收站</Option>
        </Select> -->
        <Poptip title="导出Excel" placement="left" trigger="hover">
          <Button style="margin: 0 5px 1px 0">导出Excel</Button>
          <div slot="content">
            <Button
              type="primary"
              style="margin-right: 5px"
              @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
        <Button type="primary" @click="$router.push({ name: 'charge-add' })"
          >新增计费方案</Button
        >
      </div>
    </div>
    <Table
      :columns="columns"
      :data="data"
      :loading="tableLoading"
      @on-sort-change="tableSort"
    ></Table>
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="sizeChange"
        :total="total"
        :current="page.p + 1"
        show-elevator
        show-sizer
        show-total
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import excel from '@/libs/excel'
export default {
  data () {
    return {
      page: {
        p: 0,
        limit: 10,
        cond: 'charge.id',
        value: '',
        is_del: 0, // 禁用列表
        key: 'id',
        order: 'desc'
      },
      tableLoading: false,
      columns: [],
      data: [],
      total: 0,
      confirmLoading: false,
      col: [
        {
          title: '方案名称',
          width: 120,
          key: 'name',
          fixed: 'left',
          sortable: 'custom',
          _sortKey: 'charge.name',
          show: true
        },
        {
          title: '所属',
          width: 150,
          key: 'agent_name',
          sortable: 'custom',
          _sortKey: 'user_agent.name',
          show: true
        },
        { title: 'A3彩单', minWidth: 75, key: 'a3_color_single', show: true },
        { title: 'A3彩双', minWidth: 75, key: 'a3_color_double', show: false },
        { title: 'A3黑单', minWidth: 75, key: 'a3_mono_single', show: true },
        { title: 'A3黑双', minWidth: 75, key: 'a3_mono_double', show: false },
        { title: 'A4彩单', minWidth: 75, key: 'a4_color_single', show: true },
        { title: 'A4彩双', minWidth: 75, key: 'a4_color_double', show: false },
        { title: 'A4黑单', minWidth: 75, key: 'a4_mono_single', show: true },
        { title: 'A4黑双', minWidth: 75, key: 'a4_mono_double', show: false },
        { title: 'A5彩单', minWidth: 75, key: 'a5_color_single', show: true },
        { title: 'A5彩双', minWidth: 75, key: 'a5_color_double', show: false },
        { title: 'A5黑单', minWidth: 75, key: 'a5_mono_single', show: true },
        { title: 'A5黑双', minWidth: 75, key: 'a5_mono_double', show: false },
        {
          title: '其他彩单',
          minWidth: 85,
          key: 'other_color_single',
          show: true
        },
        {
          title: '其他彩双',
          minWidth: 85,
          key: 'other_color_double',
          show: false
        },
        {
          title: '其他黑单',
          minWidth: 85,
          key: 'other_mono_single',
          show: true
        },
        {
          title: '其他黑双',
          minWidth: 85,
          key: 'other_mono_double',
          show: false
        },
        { title: '扫描', minWidth: 60, key: 'scan_single', show: true },
        { title: '证件彩色', minWidth: 85, key: 'idcard_color', show: true },
        { title: '证件黑白', minWidth: 85, key: 'idcard_mono', show: true },
        { title: '证件照冲印', minWidth: 100, key: 'idcard_print', show: true },
        { title: '照片冲印', minWidth: 85, key: 'idcard_print', show: true },
        { title: '特殊订单1', minWidth: 100, key: 'special_01', show: true },
        { title: '特殊订单2', minWidth: 100, key: 'special_02', show: true },
        { title: '特殊订单3', minWidth: 100, key: 'special_03', show: true }
      ],
      start: [
        {
          title: '编号',
          width: 80,
          key: 'id',
          fixed: 'left',
          sortable: 'custom',
          _sortKey: 'charge.id'
        }
      ],
      end: [
        {
          title: '操作',
          width: 120,
          key: 'operator',
          fixed: 'right',
          render: (h, data) => {
            return h('div', { style: { width: '85px' } }, [
              h(
                'Button',
                {
                  props: {
                    type: data.row.is_del ? 'success' : 'error',
                    size: 'small'
                  },
                  style: { marginRight: '5px' },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                        title: `是否${data.row.is_del ? '恢复' : '删除'}`,
                        content: `是否${
                          data.row.is_del ? '恢复' : '删除'
                        }该计费方案`,
                        loading: this.confirmLoading,
                        onOk: () => {
                          let temp = JSON.parse(JSON.stringify(data.row))
                          temp.is_del = temp.is_del ? 0 : 1
                          this.confirmLoading = true
                          delete temp._index
                          delete temp._rowKey
                          delete temp.agent_name
                          if (temp.is_del === 0) {
                            this.saveCharge(temp).then((res) => {
                              this.confirmLoading = false
                              data.row.is_del = temp.is_del
                            })
                          } else {
                            let cond = { charge_id: data.row.id }
                            if (this.user.tp) {
                              cond.agent_id = this.user.id
                            }
                            this.DelCharge(cond).then((res) => {
                              this.confirmLoading = false
                              if (res.status) {
                                this.$Message.success('操作完成')
                                this.getData()
                              } else {
                                this.$Message.error(
                                  '该计价方案已使用,操作失败'
                                )
                              }
                            })
                          }
                        }
                      })
                    }
                  }
                },
                data.row.is_del ? '恢复' : '删除'
              ),
              h(
                'Button',
                {
                  props: { type: 'warning', size: 'small' },
                  on: {
                    click: () => {
                      this.$router.push({
                        name: 'charge-edit',
                        params: { id: data.row.id }
                      })
                    }
                  }
                },
                '修改'
              )
            ])
          }
        }
      ]
    }
  },
  methods: {
    sizeChange (l) {
      this.page.l = l
      this.getData()
    },
    pageChange (p) {
      this.page.p = p - 1
      this.getData()
    },
    resest () {
      this.page.cond = 'charge.id'
      this.page.value = ''
      this.getData()
    },
    formatCol () {
      let temp = []
      this.col.map((item) => {
        if (item.show) {
          temp.push(item)
        }
      })
      this.columns = this.start.concat(temp).concat(this.end)
    },
    getData (filter) {
      if (filter) {
        this.page.p = 0
      }
      this.tableLoading = true
      this.getCharge(this.page).then((res) => {
        this.data = res.data
        this.total = res.total
        this.tableLoading = false
      })
    },
    // 导出数据
    exportData (is_all) {
      let title = ['编号'],
        key = ['id']
      this.col.map((item) => {
        if (item.show) {
          title.push(item.title)
          key.push(item.key)
        }
      })
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: '计费方案'
      }
      if (is_all) {
        let page = JSON.parse(JSON.stringify(this.page))
        page.l = this.total
        page.p = 0
        this.getCharge(page).then((res) => {
          params.data = res.data
          excel.export_array_to_excel(params)
        })
      } else {
        params.data = this.data
        excel.export_array_to_excel(params)
      }
    },
    // 表格排序
    tableSort (col) {
      this.page.key = col.column._sortKey
      this.page.order = col.order
      this.getData()
    },
    ...mapActions(['getCharge', 'saveCharge', 'DelCharge'])
  },
  computed: mapGetters({
    user: 'agent'
  }),
  mounted () {
    this.formatCol()
    this.getData()
  },
  watch: {
    // deep watch 查看col变动
    col: {
      handler (n, o) {
        this.formatCol()
      },
      deep: true
    },
    'page.is_del' () {
      this.getData()
    }
  }
}
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
